import { lazy } from 'react'

import { withSuspense } from '@HOCs/withSuspense'

const RequestDemoDialog = lazy(async () => {
  const { RequestDemoDialog } = await import('./RequestDemoDialog')
  return { default: RequestDemoDialog }
})

const RequestDemoDialogWithSuspense = withSuspense(RequestDemoDialog)

export { RequestDemoDialogWithSuspense as RequestDemoDialog }
